import React from "react";
import { type APIError } from "@/api/APIError";
import { TraceID } from "./TraceID";

type ErrorBoxProps = {
    error?: APIError | null;
    className?: string;
};

export function ErrorBox({ error, className }: ErrorBoxProps) {
    if (!error) return null;
    return (
        <div className={`rounded-lg border border-mid-red/60 overflow-hidden text-sm ${className ?? ""}`}>
            <p className="px-3 py-2.5 bg-light-red text-muted-red">{error.message}</p>
            {error.traceID && (
                <div className="px-3 py-2 bg-desaturated-red border-t border-mid-red/40 text-muted-red">
                    <TraceID id={error.traceID} />
                </div>
            )}
        </div>
    );
}
